module.exports = __webpack_public_path__ + "static/img/fuermei_icon.0cf2077.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/fuermei_icon.png
// module id = kmed
// module chunks = 1